export default function () {
    return {
        treesCount: {
            count: null,
            effectiveness: null,
        }
    }
}